// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"27":"3a55141d","28":"ec2ade2b","337":"ddda6f9d","959":"5ab2ac83"}[chunkId] + ".css";
};